import { lazy, Suspense, useEffect, useState } from 'react';
import { Link, Outlet, useLocation } from "react-router-dom";
import { Layout, Spin } from 'antd';
import type { SelectInfo } from 'rc-menu/lib/interface';
import { getMenuItem, TMenu } from 'types/menu';

const Header = lazy(() => import("./Header"));

const headerMenuItemsRight: TMenu[] = [
  getMenuItem((<Link to="https://auth.asinzen.com" target="_blank" rel="noopener noreferrer">Admin Dashboard</Link>), '/admin-dashboard'),
  getMenuItem('Log Out', '/logout'),
];

const headerMenuItemsLeft: TMenu[] = [
  getMenuItem(
    (<Link to="/user-management">Users</Link>),
    '/user-management'
  ),
  getMenuItem(
    (<Link to="/tools">Tools</Link>),
    '/tools'
  ),
  getMenuItem(
    (<Link to="/versions">Versions</Link>),
    '/versions'
  ),
  getMenuItem(
    (<Link to="/brands">Brands</Link>),
    '/brands'
  ),
  getMenuItem(
    (<Link to="/keepa-keys">Keepa Keys</Link>),
    '/keepa-keys'
  ),
  getMenuItem(
    (<Link to="/estimate-sales/US">Estimate Sales</Link>),
    '/estimate-sales/US'
  ),
  getMenuItem(
    'Calculator Library Unit Test',
    '#calculator',
    [
      getMenuItem(
        (<Link to="/calculator-library-unit-test/golang/fullfillment-fee/US">Fullfillment Fee</Link>),
        '/calculator-library-unit-test/golang/fullfillment-fee/US'
      ),
      getMenuItem(
        (<Link to="/calculator-library-unit-test/golang/monthly-long-term-storage-fee/US">Monthly & LT Storage Fee</Link>),
        '/calculator-library-unit-test/golang/monthly-long-term-storage-fee/US'
      ),
      getMenuItem(
        (<Link to="/calculator-library-unit-test/golang/referral-fee/US">Referral Fee</Link>),
        '/calculator-library-unit-test/golang/referral-fee/US'
      ),
      getMenuItem(
        (<Link to="/calculator-library-unit-test/golang/size-tiers-shipping-weight/US">Size Tiers & Shipping Wgt</Link>),
        '/calculator-library-unit-test/golang/size-tiers-shipping-weight/US'
      ),
    ]
  ),
  getMenuItem(
    (<Link to="/sp-token-pool">SP Token Pool</Link>),
    '/sp-token-pool'
  ),
  getMenuItem(
    'Logs',
    '#logs',
    [
      getMenuItem(
        (<Link to="/logs/rate-limit-logs" replace>Rate Limit Logs</Link>),
        '/logs/rate-limit-logs'
      ),
      getMenuItem(
        (<Link to="/logs/request-logs" replace>Request Logs</Link>),
        '/logs/request-logs'
      ),
    ]
  ),
  getMenuItem(
    'Links',
    '#links',
    [
      getMenuItem(
        (<Link to="https://goto.asinzen.com/graphana" target="_blank" rel="noopener noreferrer">Grafana</Link>),
        'https://goto.asinzen.com/graphana'
      ),
    ]
  ),
  getMenuItem(
    'AZArbitrage',
    '#AZArbitrage',
    [
      getMenuItem(
        (<Link to="/azarbitrage/manage-product-list-urls/US" replace>Manage Product List URLs</Link>),
        '/az-arbitrage/manage-product-list-urls'
      ),
      getMenuItem(
        (<Link to="/azarbitrage/manage-product-selectors/US" replace>Manage Product Selectors</Link>),
        '/azarbitrage/manage-product-selectors'
      ),
    ]
  ),
  getMenuItem(
    (<Link to="/meltable">Meltable</Link>),
    '/meltable',
  ),
];

export const MainLayout = () => {
  const [selectedMenuItem, setSelectedMenuItem] = useState<string[]>([]);
  const currentHref = useLocation();

  const handleOnSelectMenuItems = ({ selectedKeys }: SelectInfo) =>
    setSelectedMenuItem(selectedKeys);

  useEffect(() => {
    setSelectedMenuItem([currentHref.pathname])
  }, [])

  return (
    <Suspense fallback={<div className="loading-page"><Spin size="large" /></div>}>
      <Layout className="site-layout-background">
        <Header
          menuItemsLeft={headerMenuItemsLeft}
          menuItemsRight={headerMenuItemsRight}
          selectedMenuItem={selectedMenuItem}
          onSelectMenuItems={handleOnSelectMenuItems}
        />
        <Layout style={{ padding: '24px' }}>
          <Outlet />
        </Layout>
      </Layout>
    </Suspense>
  )
};